import { CiiService } from "../../services/cii/service";
import mapCiiRatingsDataFromJson from "../../domain/cii/ratings/mapper";
import { ciiContributionDataFromJson } from "../../domain/cii/contribution/mapper";
import mapCiiCurrentDataFromJson from "../../domain/cii/current/mapper";
import mapCiiVoyageDataFromJson from "../../domain/cii/voyage/mapper";
import mapCiiCalculationResultDataFromJson from "../../domain/cii/calculation/result/mapper";

const ciiService = new CiiService(
  localStorage.getItem("basicUrl"),
  mapCiiRatingsDataFromJson,
  ciiContributionDataFromJson,
  mapCiiCurrentDataFromJson,
  mapCiiVoyageDataFromJson,
  mapCiiCalculationResultDataFromJson
);

const getDefaultState = () => {
  return {
    ciiCalculationInput: null,
    ciiCalculationResult: null,
    calculationLoading: false,
    calculationError: null,
  };
};

const state = getDefaultState();

const getters = {};

const actions = {
  async calculateCiiContribution({ commit }, vesselName) {
    commit("SET_CII_CALCULATION_LOADING_STATE");
    try {
      const result = await ciiService.calculateCiiContribution(
        localStorage.getItem("quad_token"),
        vesselName,
        state.ciiCalculationInput.toInputList()
      );
      commit("SET_CII_CALCULATION_SUCCESS_STATE", result);
      commit("cii/UPDATE_CII_CONTRIBUTION_VALUES", result, { root: true });
    } catch (error) {
      commit("SET_CII_CALCULATION_ERROR_STATE", error);
    }
  }
};

const mutations = {
  SET_CII_CALCULATION_LOADING_STATE(state) {
    state.calculationLoading = true;
    state.calculationError = null;
  },
  SET_CII_CALCULATION_SUCCESS_STATE(state, result) {
    state.calculationLoading = false;
    state.calculationError = null;
    state.ciiCalculationResult = result;
  },
  SET_CII_CALCULATION_ERROR_STATE(state, error) {
    state.calculationLoading = false;
    state.calculationError = error;
  },
  SET_CII_CALCULATION_INPUT_STATE(state, input) {
    state.ciiCalculationInput = input;
  },
  SET_CII_CALCULATION_INPUT_ATTRIBUTE_STATE(state, { name, value }) {
    const attribute = state.ciiCalculationInput[name];
    attribute.input = value;
  }
};

export const ciiCalculationModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
